import { Icon } from '@sleepstation/components'
import { LinkBase } from '@sleepstation/components-base'
import { HLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_JUSTIFY } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(LinkBase)`
  position: relative;
  color: white;
  text-decoration: none;
  font-size: 18px;
`

const Label = styled.span`
  padding: 4px;
`

const Inner = styled(HLayout).attrs({
  justify: LAYOUT_JUSTIFY.CENTER,
  align: LAYOUT_ALIGN.CENTER,
})`
  cursor: pointer;
  transition: color 0.25s ease-in-out;

  &:hover {
    color: #f7b85f;
  }
`

const Badge = styled.div`
  position: absolute;
  top: 0;
  left: 7px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: #ff3050;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TopHorizontalMenuItem = ({ linkUrl, iconKey, linkText, showBadge }) => (
  <Layout href={linkUrl} forceOpenInSameWindow>
    <Inner>
      <Icon name={iconKey} />
      <Label>{linkText}</Label>
      {showBadge && <Badge />}
    </Inner>
  </Layout>
)

TopHorizontalMenuItem.propTypes = {
  linkUrl: PropTypes.string.isRequired,
  iconKey: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  showBadge: PropTypes.bool.isRequired,
}

TopHorizontalMenuItem.defaultProps = {}

export default TopHorizontalMenuItem
